import { defineComponent as _defineComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'AuraProcessingCostsSummary',
  props: {
    totalCost: { type: String, required: true },
    totalItems: { type: Number, required: true },
    totalTokens: { type: String, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();



const __returned__ = {  }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})